/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import React, { Component, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import {
  QrCode,
  RefreshCw,
  Shield,
  UserPlus,
  KeyRound,
  CheckCircle,
  AlertCircle,
  Wifi,
  WifiOff,
  Video,
  ArrowLeft,
} from "lucide-react";
import { Navigate } from "react-router-dom";
import { io } from "socket.io-client";
import Cookies from "js-cookie";

// Eski sürümler token'ı süresiz olarak localStorage'a da yazıyordu. Çerez bitince
// "yarı girişli" durum oluşmasın diye uygulama açılışında o kopyayı temizle
// (bu modül AppRouter tarafından açılışta yüklenir).
try {
  localStorage.removeItem("token");
} catch (e) {
  // localStorage erişilemezse yapılacak bir şey yok
}

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      qrCode: null,
      qrExpiry: null,
      sessionId: null,
      timerInterval: null,
      message: {
        type: "",
        text: "",
      },
      shouldRedirect: null,
      socketConnected: false,
      roomJoined: false,
      connectionAttempts: 0,
      isLoginVideoModalOpen: false,
    };
    this.socket = null;
    this.maxConnectionAttempts = 3;
    this.heartbeatInterval = null;
    this.YOUTUBE_LOGIN_VIDEO_ID = "O0Pa_5CLFvg";
    this.PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.workience.universalteam&utm_source=emea_Med";
    this.APP_STORE_URL = "https://apps.apple.com/tr/app/nm-universal-team/id6737522734?l=tr";
  }

  handleOpenLoginVideoModal = () => {
    this.setState({ isLoginVideoModalOpen: true });
  };

  handleCloseLoginVideoModal = () => {
    this.setState({ isLoginVideoModalOpen: false });
  };

  initializeSocket = () => {
    if (this.socket) {
      this.socket.disconnect();
    }

    const socketUrl =
      process.env.REACT_APP_API_WEBSOCKET || "https://workience.com";

    this.socket = io(socketUrl, {
      transports: ["websocket", "polling"],
      autoConnect: true,
      timeout: 20000,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 5000,
      forceNew: true,
    });

    this.socket.on("connect", () => {
      this.setState({
        socketConnected: true,
        connectionAttempts: 0,
        message: { type: "", text: "" },
      });

      if (this.state.sessionId) {
        this.joinSocketRoom();
      }

      this.startHeartbeat();
    });

    this.socket.on("disconnect", (reason) => {
      this.setState({
        socketConnected: false,
        roomJoined: false,
      });
      this.stopHeartbeat();
    });

    this.socket.on("connect_error", (error) => {
      const attempts = this.state.connectionAttempts + 1;
      this.setState({
        socketConnected: false,
        roomJoined: false,
        connectionAttempts: attempts,
        message: {
          type: "error",
          text:
            attempts >= this.maxConnectionAttempts
              ? "Sunucuya bağlanılamıyor. Sayfa yenileniyor..."
              : `Bağlantı kuruluyor... (${attempts}/${this.maxConnectionAttempts})`,
        },
      });

      if (attempts >= this.maxConnectionAttempts) {
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    });

    this.socket.on("reconnect", (attemptNumber) => {
      this.setState({
        socketConnected: true,
        connectionAttempts: 0,
      });

      if (this.state.sessionId) {
        this.joinSocketRoom();
      }
    });

    this.socket.on("roomJoined", (data) => {
      this.setState({
        roomJoined: true,
        message: {
          type: "success",
          text: "Bağlantı hazır! QR kodu taratabilirsiniz.",
        },
      });

      if (this.state.sessionId) {
        this.socket.emit("checkPendingEvents", this.state.sessionId);
      }
    });

    this.socket.on("roomStatus", (data) => {
      this.setState({ roomJoined: data.connected });
    });

    this.socket.on("qrOnaylandi", (data) => {
      // Oturumun tek kaynağı süreli çerez; token localStorage'a yazılmaz.
      Cookies.set("token", data.webToken, { expires: 0.16, path: "/" });
      localStorage.removeItem("token");
      // Önceki oturumdan kalan önbellek isim yeni kullanıcıya taşınmasın
      localStorage.removeItem("isim");
      localStorage.removeItem("soyisim");

      if (this.state.timerInterval) {
        clearInterval(this.state.timerInterval);
      }

      this.setState({
        message: {
          type: "success",
          text: "✅ Mobil cihazdan doğrulama yapıldı! Yönlendiriliyorsunuz...",
        },
        qrCode: null,
        qrExpiry: null,
        timerInterval: null,
      });

      setTimeout(() => {
        const redirectPath = sessionStorage.getItem("redirectAfterLogin");

        if (redirectPath) {
          sessionStorage.removeItem("redirectAfterLogin");
          window.location.href = redirectPath;
        } else {
          this.setState({ shouldRedirect: "/" });
        }
      }, 2000);
    });

    this.socket.on("error", (error) => {
      this.setState({
        message: {
          type: "error",
          text: error.message || "Bilinmeyen hata oluştu",
        },
      });
    });

    this.socket.on("pong", (data) => { });
  };

  startHeartbeat = () => {
    this.stopHeartbeat();

    this.heartbeatInterval = setInterval(() => {
      if (this.socket && this.socket.connected) {
        this.socket.emit("ping", {
          timestamp: Date.now(),
          sessionId: this.state.sessionId,
        });
      }
    }, 30000);
  };

  stopHeartbeat = () => {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  };

  joinSocketRoom = () => {
    const { sessionId } = this.state;

    if (!this.socket || !this.socket.connected) {
      return;
    }

    if (!sessionId) {
      return;
    }

    this.socket.emit("joinRoom", sessionId);

    setTimeout(() => {
      if (this.socket && this.socket.connected) {
        this.socket.emit("checkRoom", sessionId);
      }
    }, 10000);
  };

  generateQRCode = () => {
    const sessionId = Math.random().toString(36).substring(2, 15);
    const timestamp = Date.now();
    const qrData = `auth-session:${sessionId}:${timestamp}`;
    const qrExpiry = timestamp + 300000;

    this.setState(
      {
        qrCode: qrData,
        qrExpiry,
        isLoading: false,
        sessionId,
        roomJoined: false,
        message: { type: "", text: "" },
      },
      () => {
        if (this.state.socketConnected) {
          setTimeout(() => {
            this.joinSocketRoom();
          }, 500);
        } else {
          this.setState({
            message: {
              type: "warning",
              text: "Sunucuya bağlanılıyor...",
            },
          });
        }
        this.startTimer();
      }
    );
  };

  startTimer = () => {
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    const timerInterval = setInterval(() => {
      const now = Date.now();

      if (now > this.state.qrExpiry) {
        this.setState({
          qrCode: null,
          qrExpiry: null,
          roomJoined: false,
          message: {
            type: "error",
            text: "QR kod süresi doldu. Yeni kod oluşturuluyor...",
          },
        });
        clearInterval(timerInterval);

        setTimeout(() => {
          this.generateQRCode();
        }, 2000);
        return;
      }

      this.forceUpdate();
    }, 1000);

    this.setState({ timerInterval });
  };

  testConnection = () => {
    if (this.socket && this.socket.connected) {
      this.socket.emit("ping", {
        timestamp: Date.now(),
        sessionId: this.state.sessionId,
        test: true,
      });
    } else {
      this.setState({
        message: {
          type: "error",
          text: "Socket bağlı değil, yeniden bağlanıyor...",
        },
      });
      this.initializeSocket();
    }
  };

  handleVisibilityChange = () => {
    if (document.hidden) {
      this.stopHeartbeat();
    } else {
      if (this.socket && this.socket.connected) {
        this.startHeartbeat();

        if (this.state.sessionId) {
          setTimeout(() => {
            this.socket.emit("checkRoom", this.state.sessionId);
          }, 1000);
        }
      }
    }
  };

  componentDidMount() {
    if (Cookies.get("token")) {
      window.location = "/";
      return;
    }

    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    this.initializeSocket();

    setTimeout(() => {
      if (this.state.socketConnected) {
        this.generateQRCode();
      } else {
        setTimeout(() => {
          this.generateQRCode();
        }, 2000);
      }
    }, 1000);

    const redirectPath = sessionStorage.getItem("redirectAfterLogin");
    if (redirectPath && redirectPath.includes("/egitimler")) {
      const fullAppUrl = `utmobil://${redirectPath.startsWith("/") ? redirectPath.slice(1) : redirectPath}`;
      setTimeout(() => {
        window.location.href = fullAppUrl;
      }, 500);
    }
  }

  componentWillUnmount() {
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    this.stopHeartbeat();

    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );

    if (this.socket) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
      this.socket = null;
    }
  }

  refreshQRCode = () => {
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    this.setState({
      isLoading: true,
      roomJoined: false,
      message: { type: "", text: "" },
    });

    this.testConnection();

    setTimeout(() => {
      this.generateQRCode();
    }, 500);
  };

  clearMessage = () => {
    setTimeout(() => {
      this.setState({ message: { type: "", text: "" } });
    }, 5000);
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.message.text !== this.state.message.text &&
      this.state.message.text
    ) {
      this.clearMessage();
    }

    if (
      !prevState.socketConnected &&
      this.state.socketConnected &&
      this.state.sessionId &&
      !this.state.roomJoined
    ) {
      setTimeout(() => {
        this.joinSocketRoom();
      }, 1000);
    }
  }

  handleRegisterNavigation = () => {
    this.setState({ shouldRedirect: "/register" });
  };

  handleForgotNavigation = () => {
    this.setState({ shouldRedirect: "/forgot" });
  };

  renderMessage = () => {
    const { message } = this.state;
    if (!message.text) return null;

    return (
      <div
        style={{
          background:
            message.type === "success"
              ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
              : message.type === "warning"
                ? "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)"
                : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
          border: `1px solid ${message.type === "success"
            ? "#10b981"
            : message.type === "warning"
              ? "#f59e0b"
              : "#ef4444"
            }`,
          borderRadius: "12px",
          padding: "15px 20px",
          marginBottom: "25px",
          color:
            message.type === "success"
              ? "#065f46"
              : message.type === "warning"
                ? "#92400e"
                : "#991b1b",
          fontSize: "14px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {message.type === "success" ? (
          <CheckCircle size={16} />
        ) : (
          <AlertCircle size={16} />
        )}
        {message.text}
      </div>
    );
  };

  renderConnectionStatus = () => {
    const { socketConnected, roomJoined } = this.state;

    let status, color, icon;

    if (socketConnected && roomJoined) {
      status = "🟢 Hazır";
      color = "#10b981";
      icon = <Wifi size={12} />;
    } else if (socketConnected && !roomJoined) {
      status = "🟡 Bağlanıyor";
      color = "#f59e0b";
      icon = <Wifi size={12} />;
    } else {
      status = "🔴 Bağlantı Yok";
      color = "#ef4444";
      icon = <WifiOff size={12} />;
    }

    return (
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: "12px",
          color: color,
          background: "rgba(255,255,255,0.95)",
          padding: "6px 12px",
          borderRadius: "20px",
          border: `2px solid ${color}`,
          cursor: "pointer",
          fontWeight: "600",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
        onClick={this.testConnection}
        title="Bağlantıyı test et (Tıkla)"
      >
        {icon}
        {status}
      </div>
    );
  };

  renderQRCode = () => {
    const { qrCode, qrExpiry, isLoading, roomJoined } = this.state;

    if (!qrCode || isLoading) return null;

    const timeLeft = Math.max(0, Math.ceil((qrExpiry - Date.now()) / 1000));
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return (
      <div
        style={{
          textAlign: "center",
          background: "#ffffff",
          border: `3px solid ${roomJoined ? "#10b981" : "#e2e8f0"}`,
          borderRadius: "20px",
          padding: "30px",
          marginBottom: "25px",
          boxShadow: roomJoined
            ? "0 8px 30px rgba(16, 185, 129, 0.2)"
            : "0 4px 20px rgba(0,0,0,0.08)",
          position: "relative",
          transition: "all 0.3s ease",
        }}
      >
        {this.renderConnectionStatus()}

        <div
          style={{
            background: "#ffffff",
            padding: "20px",
            borderRadius: "16px",
            border: "2px solid #f1f5f9",
            margin: "0 auto 20px",
            display: "inline-block",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            opacity: roomJoined ? 1 : 0.7,
            transition: "opacity 0.3s ease",
          }}
        >
          <QRCodeSVG
            value={qrCode}
            size={220}
            level="M"
            includeMargin={true}
            fgColor="#1e293b"
            bgColor="#ffffff"
          />
        </div>

        {!roomJoined && (
          <div
            style={{
              background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
              color: "#92400e",
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "15px",
              padding: "10px 15px",
              borderRadius: "10px",
              border: "1px solid #f59e0b",
            }}
          >
            🔄 Sunucuya bağlantı kuruluyor...
          </div>
        )}

        {roomJoined && (
          <div
            style={{
              background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
              color: "#065f46",
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "15px",
              padding: "10px 15px",
              borderRadius: "10px",
              border: "1px solid #10b981",
            }}
          >
            ✅ Hazır! Mobil uygulamadan QR kodu tarayabilirsiniz
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            marginBottom: "20px",
            color:
              timeLeft < 60 ? "#ef4444" : roomJoined ? "#10b981" : "#64748b",
            fontSize: "20px",
            fontWeight: "700",
          }}
        >
          <QrCode size={24} />
          <span>
            {minutes}:{seconds.toString().padStart(2, "0")}
          </span>
        </div>

        <button
          onClick={this.refreshQRCode}
          disabled={isLoading}
          style={{
            background: isLoading
              ? "#94a3b8"
              : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            padding: "12px 24px",
            border: "none",
            borderRadius: "12px",
            fontSize: "15px",
            fontWeight: "600",
            cursor: isLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            margin: "0 auto",
            transition: "all 0.2s ease",
            boxShadow: isLoading
              ? "none"
              : "0 6px 20px rgba(102, 126, 234, 0.4)",
          }}
        >
          <RefreshCw
            size={18}
            style={{
              animation: isLoading ? "spin 1s linear infinite" : "none",
            }}
          />
          {isLoading ? "Yenileniyor..." : "Yeni QR Kod"}
        </button>
      </div>
    );
  };

  renderMobileAppSuggestion = () => {
    const redirectPath = sessionStorage.getItem("redirectAfterLogin");
    if (!redirectPath || !redirectPath.includes("/egitimler")) return null;

    const fullAppUrl = `utmobil://${redirectPath.startsWith("/") ? redirectPath.slice(1) : redirectPath}`;

    return (
      <div
        style={{
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          borderRadius: "16px",
          padding: "20px",
          marginBottom: "25px",
          border: "1px solid #bae6fd",
          textAlign: "center",
          boxShadow: "0 4px 15px rgba(14, 165, 233, 0.1)",
        }}
      >
        <h4
          style={{
            fontSize: "18px",
            fontWeight: "700",
            color: "#0369a1",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          📱 Mobil Uygulamadan Devam Et
        </h4>
        <p
          style={{
            color: "#075985",
            fontSize: "14px",
            lineHeight: "1.5",
            marginBottom: "15px",
          }}
        >
          Eğitimlerinize mobil uygulamamız üzerinden çok daha kolay ve hızlı bir
          şekilde erişebilirsiniz.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <a
            href={fullAppUrl}
            style={{
              background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
              color: "white",
              padding: "10px 20px",
              borderRadius: "10px",
              fontSize: "15px",
              fontWeight: "600",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              boxShadow: "0 4px 12px rgba(14, 165, 233, 0.25)",
              transition: "all 0.2s ease",
            }}
          >
            🚀 Uygulamada Aç
          </a>

          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <a
              href={this.PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: "#000",
                color: "white",
                padding: "6px 12px",
                borderRadius: "6px",
                fontSize: "12px",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                flex: 1,
                justifyContent: "center",
              }}
            >
              <img
                src="/Assets/Images/googleplay.png"
                alt="Play Store"
                style={{ width: "16px", height: "16px" }}
              />
              Play Store
            </a>
            <a
              href={this.APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: "#000",
                color: "white",
                padding: "6px 12px",
                borderRadius: "6px",
                fontSize: "12px",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                flex: 1,
                justifyContent: "center",
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
              </svg>
              App Store
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isLoading, qrCode, shouldRedirect, isLoginVideoModalOpen } =
      this.state;

    if (shouldRedirect) {
      return <Navigate to={shouldRedirect} replace />;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "10%",
            width: "100px",
            height: "100px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 6s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            right: "15%",
            width: "150px",
            height: "150px",
            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 8s ease-in-out infinite reverse",
          }}
        />

        <div
          className="main-container"
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
            borderRadius: "24px",
            padding: "50px",
            boxShadow: "0 25px 80px rgba(0,0,0,0.15)",
            border: "1px solid rgba(226, 232, 240, 0.5)",
            width: "100%",
            maxWidth: "520px",
            position: "relative",
            zIndex: 1,
            backdropFilter: "blur(10px)",
          }}
        >
          {/* Geri Dön Butonu */}
          <button
            onClick={() => this.setState({ shouldRedirect: "/" })}
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              background: "transparent",
              color: "#64748b",
              border: "none",
              fontWeight: "600",
              fontSize: "13px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              zIndex: 10,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1e293b";
              e.currentTarget.style.transform = "translateX(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#64748b";
              e.currentTarget.style.transform = "translateX(0)";
            }}
          >
            <ArrowLeft size={14} />
            Geri Dön
          </button>

          <div
            style={{
              position: "absolute",
              top: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
              padding: "8px 20px",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#64748b",
            }}
          >
            <Shield size={14} style={{ color: "#10b981" }} />
            Güvenli Bağlantı
          </div>

          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 25px",
              color: "white",
              boxShadow: "0 8px 25px rgba(102, 126, 234, 0.25)",
            }}
          >
            <QrCode size={35} />
          </div>

          <h2
            style={{
              textAlign: "center",
              fontSize: "32px",
              fontWeight: "700",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#1e293b",
            }}
          >
            QR Kod ile Web Girişi
          </h2>

          <div
            style={{
              textAlign: "center",
              marginBottom: "30px",
              padding: "20px",
              background: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
              borderRadius: "16px",
              border: "1px solid #c7d2fe",
              boxShadow: "0 4px 20px rgba(99, 102, 241, 0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#3730a3",
                marginBottom: "12px",
              }}
            >
              Bilgisayardan Web Sitesine Giriş
            </h3>
            <div
              style={{
                color: "#4f46e5",
                fontSize: "14px",
                lineHeight: "1.6",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              <div style={{ marginBottom: "8px" }}>
                <strong>1.</strong> Telefonunuzdan <strong>NM Universal Team</strong> mobil uygulamasına giriş yapın.
              </div>
              <div style={{ marginBottom: "8px" }}>
                <strong>2.</strong> Sağ üstteki yan menüyü (3 yatay çizgi) açıp oradaki <strong>Web Giriş</strong> seçeneğine tıklayın.
              </div>
              <div style={{ marginBottom: "8px" }}>
                <strong>3.</strong> Uygulama üzerindeki QR tarayıcı ile bu QR kodu taratarak web paneline giriş yapın.
              </div>
            </div>
            <button
              onClick={this.handleOpenLoginVideoModal}
              style={{
                background: "linear-gradient(135deg, #818cf8 0%, #6366f1 100%)",
                color: "white",
                padding: "12px 25px",
                border: "none",
                borderRadius: "10px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 6px 20px rgba(99, 102, 241, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(99, 102, 241, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(99, 102, 241, 0.3)";
              }}
            >
              <Video size={18} />
              Nasıl Giriş Yapılır?
            </button>
          </div>
          {/* Üyeliği biten kişi uygulamaya giremediği için QR okutamaz: yenileme sayfası QR istemez (SMS kodu / e-posta ile giriş) */}
          <div
            style={{
              marginBottom: "30px",
              padding: "18px 20px",
              background: "#fffbeb",
              border: "1px solid #fcd34d",
              borderRadius: "16px",
              textAlign: "left",
            }}
          >
            <div style={{ fontSize: "16px", fontWeight: "700", color: "#92400e", marginBottom: "6px" }}>
              Üyeliğinizin süresi mi doldu?
            </div>
            <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#78350f", marginBottom: "12px" }}>
              Uygulamaya giremiyorsanız QR koda gerek yok. Telefon numaranıza gelen kodla ya da e-posta adresinizle giriş
              yapıp üyeliğinizi buradan yenileyebilirsiniz.
            </div>
            <a
              href="/yenile"
              style={{
                display: "inline-block",
                background: "#b45309",
                color: "#ffffff",
                padding: "10px 20px",
                borderRadius: "10px",
                fontSize: "15px",
                fontWeight: "600",
                textDecoration: "none",
              }}
            >
              Üyeliğimi Yenile
            </a>
          </div>
          {this.renderMobileAppSuggestion()}
          {this.renderMessage()}
          {isLoading ? (
            <div
              style={{
                textAlign: "center",
                background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                border: "2px dashed #cbd5e1",
                borderRadius: "16px",
                padding: "40px 20px",
                marginBottom: "30px",
              }}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  border: "4px solid #e2e8f0",
                  borderTop: "4px solid #667eea",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto 20px",
                }}
              />
              <h3
                style={{
                  color: "#475569",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                🔄 QR Kod Oluşturuluyor...
              </h3>
              <p
                style={{
                  color: "#64748b",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                Lütfen bekleyin, güvenli bağlantı kuruluyor
              </p>
            </div>
          ) : qrCode ? (
            this.renderQRCode()
          ) : null}
          <div
            style={{
              marginTop: "30px",
              paddingTop: "25px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: "#64748b",
                fontSize: "15px",
                margin: "0 0 15px 0",
              }}
            >
              Hesabınız yok mu?
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={this.handleRegisterNavigation}
                style={{
                  background:
                    "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                  color: "white",
                  padding: "12px 25px",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 4px 15px rgba(59, 130, 246, 0.3)",
                  transition: "all 0.2s ease",
                }}
              >
                <UserPlus size={16} />
                Hesap Oluştur
              </button>

              <button
                onClick={this.handleForgotNavigation}
                style={{
                  background: "none",
                  border: "1px solid #e2e8f0",
                  color: "#64748b",
                  padding: "12px 25px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                }}
              >
                <KeyRound size={16} />
                Şifremi Unuttum
              </button>
            </div>
          </div>
        </div>

        {isLoginVideoModalOpen && (
          <div
            onClick={this.handleCloseLoginVideoModal}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.85)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "900px",
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 25px 50px rgba(0, 0, 0, 0.5)",
              }}
            >
              <div
                style={{
                  padding: "20px 25px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                  Web Sitemize Nasıl Giriş Yapılır?
                </h3>
                <button
                  onClick={this.handleCloseLoginVideoModal}
                  style={{
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "none",
                    color: "white",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.2)";
                  }}
                >
                  ✕
                </button>
              </div>

              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: 0,
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/${this.YOUTUBE_LOGIN_VIDEO_ID}?autoplay=1`}
                  title="Giriş Yapma Videosu"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>

              <div
                style={{
                  padding: "20px 25px",
                  background: "#f8fafc",
                  textAlign: "center",
                  color: "#64748b",
                  fontSize: "14px",
                }}
              >
                <p style={{ margin: 0 }}>
                  QR kod ile giriş sürecini adım adım öğrenmek için videoyu
                  izleyin.
                </p>
              </div>
            </div>
          </div>
        )}

        <style jsx>{`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes float {
            0%,
            100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-20px) rotate(180deg);
            }
          }

          @media (max-width: 768px) {
            .main-container {
              padding: 30px 25px !important;
              margin: 10px !important;
              max-width: 95% !important;
            }
          }

          @media (max-width: 480px) {
            .main-container {
              padding: 25px 20px !important;
              max-width: 100% !important;
            }
          }

          button:hover:not(:disabled) {
            transform: translateY(-2px);
            transition: all 0.2s ease;
          }

          button:active {
            transform: translateY(0);
          }

          button:focus {
            outline: 2px solid #667eea;
            outline-offset: 2px;
          }
        `}</style>
      </div>
    );
  }
}